import React from 'react'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

export default function Campus_Ambassador_qna() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className="mt-3">
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-6">
              How can I apply to become a campus ambassador for Internselite?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              To apply to become an Internselite campus ambassador, visit our
              website and go to the ‘Become an Internselite Campus Ambassador’
              section. There, you'll find an application form that you need to
              complete. The form will ask you to provide the required details.
              After you submit your application, you will receive a call from
              one of our executives who will assign a task. Once you complete
              the task successfully, you will be officially hired as a campus
              ambassador and will receive your offer letter.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-6">
              Is there any fee or specific eligibility criteria to become a
              campus ambassador for Internselite?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              There are no fees associated with becoming a campus ambassador for
              Internselite. We do not charge any application or participation
              fees. As for eligibility, we are looking for enthusiastic and
              motivated students who are currently enrolled in a university.
              While prior experience in similar roles is not required, strong
              communication skills and a genuine interest in promoting career
              development opportunities are essential. For more specific
              eligibility details, please refer to the guidelines on our ‘Become
              an Internselite Campus Ambassador’ page.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-6">
              How can I redeem the benefits of being a campus ambassador for
              Internselite?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              As a campus ambassador for Internselite, you can redeem your
              benefits based on the number of successful registrations you
              achieve:
              <br></br>5 Registrations: You will receive a Campus Ambassador
              Internship Certificate.
              <br></br>10-12 Registrations: You will be awarded either a free
              internship program in any area of your interest or a
              performance-based stipend. The stipend amount will be determined
              based on your performance and the number of registrations
              achieved.
              <br></br>18-20 Registrations: You will receive a Letter of
              Recommendation (LOR) based on your performance.
              <br></br>All details and instructions for redeeming these benefits
              will be outlined in your Campus Ambassador Letter, which you will
              receive upon your official hiring. If you have any questions or
              need further assistance, our support team is here to help.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-6">
              How will I receive my Campus Ambassador Internship Certificate,
              Letter of Recommendation (LOR), and other benefits from
              Internselite? What if I am already registered in an internship
              program?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <ul>
                <li>You will receive your Campus Ambassador Internship Certificate,
              Letter of Recommendation (LOR), and other benefits via email from{' '}
              <a href="mailto:greetings@internselite.com">
                greetings@internselite.com
              </a>{' '}
              or{' '}
              <a href="mailto:support@internselite.com">
                support@internselite.com
              </a>
              . This includes your official offer letter, which will also be
              sent from these email addresses once you are officially hired. If
              you are already registered in an internship program and are also
              serving as a campus ambassador, any registrations you secure will
              be counted as referral discounts. You will still be eligible to
              receive the Campus Ambassador Internship Certificate and the LOR
              based on your performance as a campus ambassador. Your benefits
              and official documents will be processed and sent to you through
              these email addresses.</li>
              <li>Campus Ambassador/ registered student discount/ stipend per registration breakage:-</li>
              <li>For Campus Ambassador: RS 150-250 only</li>
              <li>For Registered student: 150-250 Max only</li>
              <li>(* Applicable as per the ticket price of product/ Service)</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography className="fs-6">
              How long can I work as a campus ambassador for Internselite, and
              what support will I receive?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              There is no fixed limit on how long you can work as a campus
              ambassador for Internselite. You can continue in the role as long
              as you are actively engaged and fulfilling the program’s
              expectations. If you need any details related to our programs or
              resources to help with your engagement on campus, these will be
              provided by your hired executive. We’re committed to supporting
              you throughout your tenure to ensure you have everything needed to
              succeed in your role.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  )
}
